module.exports = __webpack_public_path__ + "static/media/contact-phone-icon.775a7628.svg";